// src/widgets/moderation/TopRiskyUsers/TopRiskyUsers.tsx
import React from 'react';
import { GetFlagsResponse, TopUser } from 'redux/reducers/moderation/types';
import { decodeRestriction } from 'untils/transformFlagCounts';
import { Badge } from '../Badge/Badge';
import { Card } from '../Card/Card';
import './TopRiskyUsers.scss';

type FlagLike = {
  id: number;
  name?: string; // "IllegalNude"
  value?: number; // 2, 4, 8, 32...
  description?: string; // "Nude content", "Pornography"
};

const buildRestrictionLabelMap = (flagsState: any) => {
  const map = new Map<number, string>();

  const arr: FlagLike[] = Array.isArray(flagsState) ? flagsState : flagsState?.data ?? [];

  for (const f of arr) {
    const code = typeof f?.value === 'number' ? f.value : undefined;
    if (code == null) continue;

    // ✅ що показуємо в UI:
    // пріоритет: description (людська) -> name -> code
    const label = (f.description || f.name || String(code)).trim();
    map.set(code, label);
  }

  return map;
};

export type RiskyUserRow = {
  id: number;
  username: string;
  registerAt?: string;
  lastLogin?: string;
  violationsTotal: number;
  byRestriction: Array<{ label: string; cnt: number }>;
};

type Props = {
  users: TopUser[];
  flags: GetFlagsResponse | null;
  onOpenUser: (userId: number) => void;
};

export const TopRiskyUsers: React.FC<Props> = ({ flags, users, onOpenUser }) => {
  return (
    <Card className="md-users" title="Top risky users">
      {users.length === 0 ? (
        <div className="md-users__empty">No data.</div>
      ) : (
        <div className="md-users__list">
          {users?.map((user) => (
            <div key={user.id} className="md-users__item">
              <div className="md-users__main">
                <button
                  className="md-users__username"
                  type="button"
                  onClick={() => onOpenUser(user.id)}
                >
                  {user.username}
                </button>

                <div className="md-users__meta">
                  {user.register_at && (
                    <span className="md-users__meta-item">Reg: {user.register_at}</span>
                  )}
                  {user.last_login && (
                    <span className="md-users__meta-item">Last: {user.last_login}</span>
                  )}
                </div>

                <div className="md-users__breakdown">
                  {(user.restrictions ?? [])?.slice(0, 3)?.map((x) => (
                    <Badge
                      key={x.restriction}
                      text={
                        decodeRestriction(x.restriction, flags?.data ?? [])[0]?.description ||
                        `Restriction ${x.restriction}`
                      }
                      variant="default"
                    />
                  ))}
                </div>
              </div>

              <div className="md-users__right">
                <div className="md-users__total">{user.violations_count}</div>
                <div className="md-users__caption">violations</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
